import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const ProfilePreviewPanel = ({ formData }) => {
  const getBlurClass = () => {
    const intensity = formData?.blurIntensity || 0;
    if (intensity < 30) return '';
    if (intensity < 60) return 'blur-sm';
    if (intensity < 80) return 'blur-md';
    return 'blur-lg';
  };

  const displayName = formData?.displayName || 'Anonymous User';
  const age = formData?.age || '—';
  const city = formData?.city || 'Location Hidden';
  const bio = formData?.bio || 'No bio added yet';
  const interests = formData?.interests || [];
  const photos = formData?.photos || [];

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 shadow-warm sticky top-20">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Eye" size={20} color="var(--color-primary)" />
        <h3 className="text-base md:text-lg font-heading font-semibold">Profile Preview</h3>
      </div>
      <div className="space-y-4">
        <div className="relative aspect-[3/4] rounded-lg overflow-hidden bg-muted">
          {photos?.length > 0 ? (
            <Image
              src={photos?.[0]?.url}
              alt={photos?.[0]?.alt}
              className={`w-full h-full object-cover ${getBlurClass()}`}
            />
          ) : (
            <div className="w-full h-full flex flex-col items-center justify-center gap-2">
              <Icon name="User" size={48} color="var(--color-muted-foreground)" />
              <span className="text-sm text-muted-foreground">No photo</span>
            </div>
          )}
          <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-background/90 to-transparent">
            <h4 className="text-lg font-heading font-semibold text-white drop-shadow-lg">
              {displayName}, {age}
            </h4>
            <div className="flex items-center gap-1 text-white/90 drop-shadow">
              <Icon name="MapPin" size={14} />
              <span className="text-sm">{city}</span>
            </div>
          </div>
        </div>

        <div>
          <h5 className="text-sm font-caption font-semibold mb-2">About</h5>
          <p className="text-sm text-muted-foreground line-clamp-3">{bio}</p>
        </div>

        {interests?.length > 0 && (
          <div>
            <h5 className="text-sm font-caption font-semibold mb-2">Interests</h5>
            <div className="flex flex-wrap gap-2">
              {interests?.slice(0, 6)?.map((interest, index) => (
                <span
                  key={index}
                  className="px-2 py-1 bg-muted rounded-full text-xs font-medium"
                >
                  {interest}
                </span>
              ))}
              {interests?.length > 6 && (
                <span className="px-2 py-1 bg-primary/10 text-primary rounded-full text-xs font-medium">
                  +{interests?.length - 6} more
                </span>
              )}
            </div>
          </div>
        )}

        <div className="p-3 bg-primary/10 rounded-lg">
          <p className="text-xs text-foreground flex items-start gap-2">
            <Icon name="Info" size={14} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
            This is how your profile appears to others with current privacy settings
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProfilePreviewPanel;